import React from "react"
import styled from "styled-components"
import { ReactComponent as FacebookIcon } from "images/social_facebook.svg"
import { ReactComponent as InstagramIcon } from "images/social_instagram.svg"
import { ReactComponent as LinkedinIcon } from "images/social_linkedin.svg"
import { ReactComponent as TwitterIcon } from "images/social_twitter.svg"
import { ReactComponent as YoutubeIcon } from "images/social_youtube.svg"
import { categories } from "./colors"

const Links = styled.div`
  display: flex;
  margin-bottom: 12px;

  a {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-right: 14px;
    width: 38px;
    height: 38px;
    background: black;
    border-radius: 50%;
    transition: background-color 0.21s ease-out;

    &:hover,
    &:focus {
      background-color: #888;
      ${({ category }) =>
        category &&
        `
          background-color: ${categories[category]};
        `}
    }

    &:last-child {
      margin-right: 0;
    }

    svg {
      width: 20px;
      height: 20px;

      * {
        fill: white;
      }
    }
  }
`

const SocialIcons = (props) => {
  const { links, category } = props

  const renderIcon = (link, index) => {
    if (link.site.match(/face|fb/gi)) {
      return (
        <a href={link.url} key={index} target="_blank" rel="noopener noreferrer" className="social">
          <span className="sr-only">Facebook</span>
          <FacebookIcon />
        </a>
      )
    } else if (link.site.match(/insta|gram/gi)) {
      return (
        <a href={link.url} key={index} target="_blank" rel="noopener noreferrer" className="social">
          <span className="sr-only">Instagram</span>
          <InstagramIcon />
        </a>
      )
    } else if (link.site.match(/linked/gi)) {
      return (
        <a href={link.url} key={index} target="_blank" rel="noopener noreferrer" className="social">
          <span className="sr-only">Linkedin</span>
          <LinkedinIcon />
        </a>
      )
    } else if (link.site.match(/tube/gi)) {
      return (
        <a href={link.url} key={index} target="_blank" rel="noopener noreferrer" className="social">
          <span className="sr-only">Youtube</span>
          <YoutubeIcon />
        </a>
      )
    } else if (link.site.match(/twit/gi)) {
      return (
        <a href={link.url} key={index} target="_blank" rel="noopener noreferrer" className="social">
          <span className="sr-only">Twitter</span>
          <TwitterIcon />
        </a>
      )
    } else {
      return ""
    }
  }

  return <Links category={category}>{links.map((link, index) => renderIcon(link, index))}</Links>
}

export default SocialIcons
